import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=c538b858&scoped=true&"
import script from "./CommentsList.vue?vue&type=script&lang=js&"
export * from "./CommentsList.vue?vue&type=script&lang=js&"
import style0 from "./CommentsList.vue?vue&type=style&index=0&id=c538b858&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./CommentsList.vue?vue&type=style&index=1&id=c538b858&prod&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c538b858",
  null
  
)

export default component.exports